import MenuItem from '../MenuItem/MenuItem'
import { MenuItemProps } from '../MenuItem/MenuItem'
import React from 'react'

interface SidebarProps {
  sidebarNavigation: MenuItemProps[]
}

const Sidebar: React.FC<SidebarProps> = ({
  sidebarNavigation,
}) => {
  return (
    <div className="hidden w-24 h-full min-h-screen overflow-hidden bg-blue-1 md:flex">
      <div className="overflow-y-auto md:block">
        <div className="flex flex-col items-center w-full">
          <div className="flex-1 w-full space-y-1">
            {sidebarNavigation &&
              sidebarNavigation.map((item, index) => (
                <MenuItem
                  key={index}
                  href={item.href}
                  icon={item.icon}
                  name={item.name}
                  current={item.current}
                />
              ))}
          </div>
        </div>
      </div>
    </div>
  )
}

export default Sidebar
